import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../BaseModule/Components/BaseModal/BaseModal';
import ContactMyDoctor from './ContactMyDoctor';

const ContactMyDoctorModal: React.FC<BaseModalProps> = props => {
	return (
		<BaseModal
			title='component.searchCaseContactNoResults.contactMyDoctor'
			{...props}
		>
			<ContactMyDoctor onSuccess={props.onClose} />
		</BaseModal>
	);
};

export default ContactMyDoctorModal;
